import { useEffect, EffectCallback } from "react";

/**
 * Run's an effect on mount.
 *
 * When a callback function is returned inside of the effect, it will be called for cleanup
 * when this hook unmounts.
 *
 * Can be considered a syntactic sugar atop a simple useEffect(cb, [])
 */
function useMountEffect(effect: EffectCallback) {
  return useEffect(effect, []);
}

export default useMountEffect;
